import React, {Fragment} from 'react';
import {useSelector} from "react-redux";
import {get} from "dot-prop-immutable";

const AdmissionList_Header_ManagerCustomUI = ({position, getClassNamesFor, requestSort}) => {
    const managerCustomUI_unified = useSelector(state => state.auth.selectedHospital.managerCustomUI_unified);
    const _items = get(managerCustomUI_unified, `admission_list.${position}`, []);

    if (!_items.length) return null;

    const renderHeader = (customUI, key) => {
        switch (customUI.type) {
            case 'TYPE_ADMISSION_LIST_SEND_AM':
                return <th key={`cid_${customUI.id}_${position}`} className="no-sort"><strong className="title">{customUI.columnTitle}</strong></th>
            case 'TYPE_ADMISSION_LIST_UPLOAD_PDF':
                return <th key={`cid_${customUI.id}_${position}`} className="no-sort"><strong className="title" key={key}>{customUI.columnTitle}</strong></th>
            case 'TYPE_ADMISSION_LIST_PRE_ADMISSION_INTEGRATION':
                return <th key={`cid_${customUI.id}_${position}`} className="no-sort"><strong className="title" key={key}>{customUI.columnTitle}</strong></th>
            case 'TYPE_ADMISSION_LIST_COMMENTS':
                return <th key={`cid_${customUI.id}_${position}`} className={`${getClassNamesFor(customUI.sort_property)} custom-ui-sort-header`}
                           onClick={() => requestSort(customUI.sort_property, false)}><strong className="title"
                                                                                              key={`comm_${key}`}>{customUI.header_title}</strong>
                </th>
            case 'TYPE_ADMISSION_LIST_SEND_REG_MED':
                return <Fragment key="reg-med">
                    <th key={`cid_${customUI.id}_${position}`} className={getClassNamesFor('customui_reg_sort')} onClick={() => requestSort('customui_reg_sort')}><strong className="title" key={`reg_${key}`}>REG</strong></th>
                    <th key={`cid2_${customUI.id}_${position}`} className={getClassNamesFor('customui_med_sort')} onClick={() => requestSort('customui_med_sort')}><strong className="title" key={`med_${key}`}>MED</strong></th>
                </Fragment>
            case 'TYPE_ADMISSION_LIST_COLUMN_SEND2':
                if (customUI.sort_property) {
                    return (
                        <th key={`cid_${customUI.id}_${position}`} className={getClassNamesFor(customUI.position)} onClick={() => requestSort(customUI.position)}><strong className="title" key={`customui_${key}`}>{customUI.columnTitle}</strong></th>
                    );
                } else {
                    return (
                        <th key={`cid_${customUI.id}_${position}`} className="no-sort"><strong className="title" key={key}>{customUI.columnTitle}</strong></th>
                    );
                }
            default:
                console.error("Unknown CustomUI custom UI type", customUI);
                break;
        }
    }

    return _items.map(renderHeader)
}

export default AdmissionList_Header_ManagerCustomUI;